<!-- <ion-tabs>
  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="home">
      <ion-icon name="home-outline"></ion-icon>
      <ion-label>{{'Hotel' | translate}}</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="concierge"
      *ngIf="
      dataServ.rData
      && dataServ.rData.other_services.show 
      && dataServ.rData.other_services.menu_categories 
      && dataServ.rData.other_services.menu_categories.length > 0"
    >
      <div class="icon concierge"></div>
      <ion-label>{{'Concierge' | translate}}</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="services"
      *ngIf="dataServ.requestActive && dataServ.liveRequests && dataServ.liveRequests.length > 0"
    >
      <div class="icon services"></div>
      <ion-label>{{'Services' | translate}}</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="chat"
      *ngIf="dataServ.rData && dataServ.rData.show_chat"
    >
      <div
        class="icon {{(chatServ.badge > 0 || (authServ.profile && authServ.profile.chat_badge > 0)) ? 'messages-badge' : 'messages'}}"
      ></div>
      <ion-label>{{'Messages' | translate}}</ion-label>
    </ion-tab-button>

    <ion-tab-button
      tab="profile"
      *ngIf="dataServ.rData.register_auth_type !== 'disable_authentication'"
    >
      <div class="icon profile"></div>
      <ion-label>{{'Profile' | translate}}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs> -->

<ion-tabs>
  <ng-container *ngIf="(!dataServ.rData )|| (dataServ.rData?.hotel_type !== 'Free')">
    <ion-tab-bar slot="bottom">
      <ng-container *ngFor="let button of this.dataServ.bottomButtonConfig">
        <ion-tab-button tab="{{button.route}}" *ngIf="(button.show) && (button.route === 'concierge' ? (dataServ.rData.other_services.show_only_logged ? authServ.isLogged : true) : true)">
          <ion-icon
            *ngIf="button.show_icon"
            class="icon"
            src="{{button.icon_url}}"
          ></ion-icon>
          <ion-label class="button-label">{{button.name | caption}}</ion-label>
        </ion-tab-button>
      </ng-container>
    </ion-tab-bar>
  </ng-container>
</ion-tabs>

<div class="use-mobile">
  <ion-icon name="phone-portrait-outline" color="primary"></ion-icon>
  <ion-text color="primary" class="ion-text-center">
    <h1>{{'Please use mobile phone for use our systems.' | translate}}</h1>
  </ion-text>
</div>
